import { render } from "./AIMLModelling.vue?vue&type=template&id=3ace2a9e"
import script from "./AIMLModelling.vue?vue&type=script&lang=js"
export * from "./AIMLModelling.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__